module.exports = __webpack_public_path__ + "img/bannerText3.62c269ee.png";